
import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./app.css";
import '@coreui/coreui/dist/css/coreui.min.css';


import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-video.css';


import AdminLayout from "layouts/Admin.js";
import Login from "views/login/login.js";
import ForgotPassword from "views/login/ForgotPassword.js";
import "components/Sidebar/Sidebar.css";
import { ToastProvider } from "components/ui/ToastContainer";
import ErrorBoundary from "components/ui/ErrorBoundary";
import { Provider, useSelector } from "react-redux";
import { store } from "./redux/store";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

const AuthRoute = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);

  return isLoggedIn ? <Navigate to="/admin/dashboard" replace /> : children;
};

const AppRoutes = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  console.log({isLoggedIn})
  
  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <Routes>
        <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
        <Route path="/forgot-password" element={<AuthRoute><ForgotPassword /></AuthRoute>} />
        <Route path="/admin/*" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>} />
        <Route path="/" element={<Navigate to={isLoggedIn ? "/admin/dashboard" : "/login"} replace />} />
      </Routes>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </ErrorBoundary>
  </Provider>
);
